import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const ContentAgreement = () => {
  const { t } = useTranslation();

  const tc = e => t(`contentagreement:${e}`, { returnObjects: true });

  return (
    <div>
      <div className="modal-header">
        <h3 className="modal-title text-center" tabIndex="-1" style={{ outline: '0px' }}>
          {tc('COMPANY')}
        </h3>
        <h3 className="modal-title text-center">{tc('CONTENT_AGREEMENT_TITLE')}</h3>
      </div>
      <div id="about" className="modal-body content-link" style={{ height: '250px', overflowY: 'scroll' }}>
        <h6>{tc('CONTENT_AGREEMENT_SUB_TITLE')}</h6>
        {tc('CONTENT_AGREEMENT_DESC')}
        <p></p>
        {tc('CONTENT_AGREEMENT_LIST').map((item, i) => (
          <Fragment key={i}>
            <p>
              <b>{item.TITLE}</b>
            </p>
            {item.CONTENT.map((e, j) => (
              <p key={j}>{e}</p>
            ))}
          </Fragment>
        ))}

        <p></p>
      </div>
      <div className="modal-footer copyright-about"></div>
    </div>
  );
};

export default ContentAgreement;